import React from 'react';
import { 
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFViewer,
    Image,
  } from "@react-pdf/renderer";

  import Certificate from '../../assets/Certificate.png';
  // Create styles
  const styles = StyleSheet.create({
    viewer: {
        width: window.innerWidth, //the pdf viewer will take up all of the width and height
        height: window.innerHeight,
    },
    page: {
        backgroundColor: "#fff",
        color: "#fff",
    },
    section: {
        alignItems: "center"
    },
    image: {
      height: '100%',
    },
    div: {
      position: "absolute",
      top: 300,
      left: 250,
      width: 600,
      fontSize: 20,
      textAlign: "center",
    }
  });
  
  export default function Certification({name, ...rest}) {
    return (
      <PDFViewer title="Certificado 5º ExpoPrev" style={styles.viewer}>
        <Document>
          {/*render a single page*/}
          <Page size="A4" orientation="landscape" style={styles.page}>
            <View style={styles.section}>
                <Image src={Certificate} style={styles.image}/>
                <View style={styles.div}>
                  <Text>{name}</Text>
                </View>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    );
};